import React from 'react';
import PropTypes from "prop-types";
import {startOfDay} from "date-fns";

import {DateFormatter} from "../../../../services/date";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Typography from "@mui/material/Typography";


const getGuestNotificationStatus = (booking) => {
    const today = new Date();
    const dayOffset = 7;
    const arrivalDate = startOfDay(booking.getArrival());
    const weekBeforeArrivalDate = new Date(arrivalDate - dayOffset * 24 * 60 * 60 * 1000)

    const scheduledDay = weekBeforeArrivalDate >= today ? weekBeforeArrivalDate : today

    if (!!booking.checkinEmailSentAt) {
        return `L'email di notifica per il check-in online è stata inviata il ${DateFormatter.longString(booking.checkinEmailSentAt)}.`
    } else if (scheduledDay > today) {
        return `L'email di notifica per il check-in online sarà inviata il ${DateFormatter.longString(scheduledDay)}.`
    } else if (scheduledDay === today) {
        return `L'email di notifica per il check-in online sarà inviata oggi.`
    } else {
        return "L'email di notifica per il check-in online è non è stata inviata."
    }
}

// Main Component
const SectionCheckInAlert = ({booking}) => {
    const guestsMismatch = booking.getNumberOfPeople() !== booking.guests.length;
    const checkInOpen = booking.checkInOpen();
    const bookingIsInThePast = booking.isInThePast();
    const beforeCheckInOpen = booking.beforeCheckInOpen();
    const checkInDone = booking.isCheckInDone();

    return <>
        {
            booking.guestNotes &&
            <Alert severity="info">
                <AlertTitle>Note/Richieste dell'ospite:</AlertTitle>
                {booking.guestNotes}
            </Alert>
        }

        {
            booking.isOnlineCheckInDone() ?
                <>
                    <Alert severity="success">
                        <AlertTitle>Check-In Online Completato</AlertTitle>
                        <Typography variant="body2" color="text.success">
                            Orario d'arrivo indicato: <b>{booking.getExpectedArrivalLabel()}</b>
                        </Typography>
                        <Typography variant="body2" color="text.success">
                            Numero ospiti
                            inseriti: <b>{`${booking.guests.length} su ${booking.getNumberOfPeople()}`}</b>
                        </Typography>
                        <Typography variant="body2" color="text.success">
                            Documento
                            d'identità: <b>{booking.hasAtLeastOneIdDocument() ? "Presente" : "Non inserito"}</b>
                        </Typography>
                    </Alert>

                    {
                        !booking.hasRequiredAlloggiatiDocuments() && !checkInDone && !bookingIsInThePast &&
                        <Alert severity="warning" sx={{mt: 3}}>
                            {
                                booking.alloggiatiDocumentsRequired <= 1 ?
                                    `Nessun documento identificativo inserito. Per poter caricare le schedine 
                                     sul portale Alloggiati (Polizia di Stato) sarà necessario inserire manualmente 
                                     almeno un documento di un ospite.`
                                    :
                                    `Per poter caricare le schedine sul portale Alloggiati (Polizia di Stato) sarà
                                     necessario inserire manualmente i documenti di 
                                     ${booking.alloggiatiDocumentsRequired} ospiti.`
                            }
                        </Alert>
                    }

                    {
                        guestsMismatch && !checkInDone && !bookingIsInThePast &&
                        <Alert severity="warning" sx={{mt: 3}}>
                            Attenzione, il numero di persone inserite dall'ospite è diverso da quello indicato nella
                            prenotazione. Puoi comunque effettuare il check in e aggiungere o rimuovere ospiti.
                        </Alert>
                    }
                </>
                :
                <>
                    {
                        !booking.email && beforeCheckInOpen &&
                        <Alert severity="error" sx={{mt: 3}}>
                            <AlertTitle>Check-in Online non attivo</AlertTitle>
                            Non verrà inviata all'ospite l'email per la notifica del check in online.
                            Per attivare la notifica automatica assicurarsi che sia presente il campo email
                            associato alla prenotazione.
                        </Alert>
                    }
                    {
                        booking.email && beforeCheckInOpen &&
                        <Alert severity="info">
                            <AlertTitle>Check-in Online in attesa</AlertTitle>
                            {getGuestNotificationStatus(booking)}
                        </Alert>
                    }
                    {
                        !booking.email && checkInOpen && !checkInDone && booking.guests.length === 0 &&
                        <Alert severity="warning" sx={{mt: 3}}>
                            <AlertTitle>Check-in Online non attivo</AlertTitle>
                            Il check in online non era attivo per questa prenotazione. Per poter caricare le schedine
                            sul portale Alloggiati (Polizia di Stato) sarà necessario inserire manualmente almeno un
                            documento di un ospite e l'anagrafica di tutti gli ospiti.
                        </Alert>
                    }
                    {
                        booking.email && checkInOpen && !checkInDone && booking.guests.length === 0 &&
                        <Alert severity="warning" sx={{mt: 3}}>
                            <AlertTitle>Check-in Online non completato</AlertTitle>
                            L'ospite non ha effettuato il check in online. Per poter caricare le schedine sul portale
                            Alloggiati (Polizia di Stato) sarà necessario inserire manualmente almeno un documento di
                            un ospite e l'anagrafica di tutti gli ospiti.
                        </Alert>
                    }
                </>
        }
    </>
};

SectionCheckInAlert.propTypes = {
    booking: PropTypes.object.isRequired,
};

export default SectionCheckInAlert;